// src/App.jsx
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Layout from './Components/Layout/Layout';
import DashboardLayout from './Components/Layout/DashboardLayout';
import GlobalLoader from './Components/GlobalLoader/GlobalLoader';

import Home from './Pages/Home/Home';
import Explore from './Pages/Explore/Explore';
import TermsPrivacy from './Pages/TermsPrivacy/TermsPrivacy';
import Login from './Pages/Login/Login';
import Signup from './Pages/Signup/Signup';
import ForgotPassword from './Pages/ForgotPassword/ForgotPassword';
import ResetPassword from './Pages/ResetPassword/ResetPassword';
import About from './Pages/About/About';
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute';
import HomeDash from './Pages/Dashboard/HomeDash';
import UploadDash from './Pages/Dashboard/UploadDash';
import ProfileDash from './Pages/Dashboard/ProfileDash';
import ExploreDash from './Pages/Dashboard/ExploreDash';
import Messages from './Pages/Dashboard/Messages';
import UserProfileDash from './Pages/Dashboard/UserProfileDash';
import i18n from './i18';

const OAuthCallback = () => <Navigate to="/login" replace />;

function App() {
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('theme');
    const theme = saved || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    document.documentElement.setAttribute('data-theme', theme);
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem('language');
    if (saved === 'zh') {
      localStorage.setItem('language', 'zh-Hans');
      i18n.changeLanguage('zh-Hans');
    }
  }, []);

  useEffect(() => {
    const initCsrf = async () => {
      try {
        await fetch(`${process.env.REACT_APP_API_URL}/get-csrf/`, {
          credentials: 'include',
        });
      } catch (e) {
        console.warn('CSRF preload failed');
      } finally {
        // small delay so loader is visible but not annoying
        setTimeout(() => setBooting(false), 600);
      }
    };
    initCsrf();
  }, []);

  if (booting) {
    // only on very first load
    return <GlobalLoader />;
  }

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/terms-and-privacy" element={<TermsPrivacy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:uidb64/:token/" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<OAuthCallback />} />
        

        {/* Public pages with Layout */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/about" element={<About />} />
        </Route>

        {/* Protected Dashboard Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/homedash" element={<HomeDash />} />
            <Route path="/uploaddash" element={<UploadDash />} />
            <Route path="/profiledash" element={<ProfileDash />} />
            <Route path="/exploredash" element={<ExploreDash />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/messages/:id" element={<Messages />} />
            <Route path="/user/:id" element={<UserProfileDash />} />
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
